import { render, staticRenderFns } from "./OpcionesSlider.vue?vue&type=template&id=e8ed8af4&"
import script from "./OpcionesSlider.vue?vue&type=script&lang=js&"
export * from "./OpcionesSlider.vue?vue&type=script&lang=js&"
import style0 from "./OpcionesSlider.vue?vue&type=style&index=0&id=e8ed8af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports